import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { SearchProperty } from 'views/property/search'

const SearchPropertyPage: NextPage = () => {
    const { formatMessage } = useIntl()

    return (
        <>
            <Header bordered={false} />
            <SearchProperty />
            <Footer />
        </>
    )
}

export default SearchPropertyPage
